import { render, staticRenderFns } from "./CombineCategories.vue?vue&type=template&id=dcbe876a&scoped=true&"
import script from "./CombineCategories.vue?vue&type=script&lang=js&"
export * from "./CombineCategories.vue?vue&type=script&lang=js&"
import style0 from "./CombineCategories.vue?vue&type=style&index=0&id=dcbe876a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcbe876a",
  null
  
)

export default component.exports